export default () => import(/* webpackChunkName: 'coffee/test/tools' */ './Tools');
